import { vdkEmHappinessPortalApi } from './vdk-em-happiness-portal-api';
import { convertModelToFormData } from '@application/helpers/form-data-helper';
const mapCreateToApi = (partnerId, request) => {
    const mapped = {
        PartnerId: partnerId,
        FirstName: request.firstName,
        LastName: request.lastName,
        Name: request.name,
        PhoneNo: request.phoneNo,
        Email: request.email,
        IsPrimary: request.isPrimary,
        ProfilePicture: request.profilePicture ?? null
    };
    return mapped;
};
const mapUpdateToApi = (partnerId, request) => {
    const mapped = {
        PartnerId: partnerId,
        FirstName: request.firstName,
        LastName: request.lastName,
        Name: request.name,
        PhoneNo: request.phoneNo,
        Email: request.email,
        IsPrimary: request.isPrimary,
        ProfilePicture: request.profilePicture ?? null
    };
    return mapped;
};
const createPartnerContactPerson = (partnerId, request) => {
    const formData = convertModelToFormData(mapCreateToApi(partnerId, request));
    return vdkEmHappinessPortalApi.post('/partnercontactpersons/create', formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
    });
};
const updatePartnerContactPerson = (partnerId, request) => {
    const formData = convertModelToFormData(mapUpdateToApi(partnerId, request));
    return vdkEmHappinessPortalApi.put(`/partnercontactpersons/${request.id}`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
    });
};
const deletePartnerContactPerson = (id) => {
    return vdkEmHappinessPortalApi.delete(`/partnercontactpersons/${id}`);
};
const partnerContactPersonAPI = {
    createPartnerContactPerson,
    updatePartnerContactPerson,
    deletePartnerContactPerson
};
export default partnerContactPersonAPI;
